// src/pages/seller/Seller2Net/services/sellerNetService.js
import api from "../../../../api/axios";

export const getUserTemplate = async (companyId) => {
  try {
    const res = await api.get(`/user-template/group/seller/${companyId}`);
    return res.data?.data || [];
  } catch (err) {
    console.error("getUserTemplate error:", err);
    throw err;
  }
};


export const saveSellerCalc = async (payload) => {
  try {
    const res = await api.post(`/seller`, payload);
    return res?.data?.data;
  } catch (error) {
    console.error("Save Seller calc error:", error);
    throw error;
  }};

export const updateSellerCalc = async (payload)=>{
  try {
    const res = await api.put(`/seller/${payload.id}`, payload);
    return res?.data?.data;
  } catch (error) {
    console.error("Update Seller calc error:", error);
    throw error;
  }
}

export const getSellerCalc = async (id) => {
  try {
    const res = await api.get(`/seller/${id}`);
    return res?.data?.data;
  } catch (error) {
    console.error("Get Seller calc error:", error);
    throw error;
  }
};